<div class="welcome-container">
  <div class="welcome-inner">
    <div class="welcome-left">
      <div class="welcome-dots">
        <img src="assets/images/dot-pulse.png" alt="Dots" />
      </div>
      <sh-text size="super-header" class="welcome-heading"> Welcome to ExpertGuidance </sh-text>
    </div>
    <div class="welcome-right">
      <img src="assets/images/aspect-object.png" alt="Welcome Image" />
    </div>
  </div>
</div>
